var _ = require('underscore'),
  React = require('react'),
  ReactSlider = require('react-slider'),
  ClassNames = require('classnames');

var CustomPropTypes = require('../types.jsx'),
  Utils = require('../utils.jsx');

var ProgressBar = React.createClass({
  propTypes: {
    role: React.PropTypes.string.isRequired,
    timePercentage: React.PropTypes.number,

    className: CustomPropTypes.ClassNameType
  },
  render: function () {
    var percent = (this.props.timePercentage || 0);
    var percentage = (this.props.timePercentage || 0).toString() + '%';
    var className = Utils.ClassNames('player-progress', this.props.className);
    return (
      <div className={ClassNames(className)}>
        <ReactSlider
          value={percent}
          orientation='horizontal'
          className='player-progress-wrapper'
          handleClassName='player-progress-handler'
          barClassName='player-progress-bar'
          onChange={this.props.onChange || function () {}}
          withBars />
      </div>
    );
  }
});

module.exports = ProgressBar;



// WEBPACK FOOTER //
// ./src/app/components/progress/sliding-bar.jsx